var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.935,
    height: 17,
    viewBox: "0 0 14.935 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #606060;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8327",
    "data-name": "Group 8327",
    transform: "translate(-457.5 -563.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    className: "cls-1",
    d: "M44.607,77.681H37.875a1.222,1.222,0,0,1-1.223-1.117l-1.06-11.7a.258.258,0,0,1,.257-.282H46.632a.258.258,0,0,1,.257.282l-1.06,11.7A1.222,1.222,0,0,1,44.607,77.681Z",
    transform: "translate(423.717 502.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    className: "cls-1",
    d: "M116.4,3.481h-5.225a.258.258,0,0,1-.258-.258V1.618A1.043,1.043,0,0,1,111.959.576h3.657a1.043,1.043,0,0,1,1.042,1.042V3.223A.258.258,0,0,1,116.4,3.481Z",
    transform: "translate(351.195 563.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    className: "cls-2",
    d: "M736,313.959h13.934",
    transform: "translate(-278.004 252.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    className: "cls-2",
    d: "M-4821.268-21686.6l-.423,6.547",
    transform: "translate(5288.871 22256.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    className: "cls-2",
    d: "M-4823.515-21686.6v6.551",
    transform: "translate(5288.473 22256.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    className: "cls-2",
    d: "M-4825.691-21686.6l.413,6.559",
    transform: "translate(5287.999 22256.789)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.62fd04803281c92bdbad19c1f4cecad9.svg";
export { ForwardRef as ReactComponent };